export const availableRoutes = {
  titlePage: "/",
  steps: "/steps"
};
